
import { Component, Prop, Ref, Vue } from 'vue-property-decorator'
import ModalAcademyData from '@/components/templates/manage/ModalAcademyData.vue'
import { AcademiesApi } from '@/api/methods/manage/AcademiesApi'
import StringUtils from '@/utils/StringUtils'

/**
 * 塾情報編集モーダル
 */
@Component({
  components: {
    ModalAcademyData,
  },
})
export default class ModalEditAcademy extends Vue {
  /** 塾情報モーダルのフォーマット */
  @Ref()
  modalAcademyData!: ModalAcademyData

  /** 塾更新後の処理 */
  @Prop()
  private afterUpdateAcademy!: () => Promise<void>

  /** 更新対象の塾ID */
  private academyId = 0

  /**
   * 送信ボタンのdisabled制御
   *
   * @param academyName 塾名
   * @param _academyCode 塾コード(編集モーダルでは不使用)
   * @returns 未入力があった場合はtrue
   */
  private submitDisabled(academyName: string, _academyCode: string): boolean {
    // 塾名が未入力の場合true
    if (StringUtils.isBlank(academyName)) {
      return true
    }

    return false
  }

  /**
   * 確認ボタン押下時の処理
   */
  private async submit(): Promise<void> {
    this.$loading.start()

    let errorMessage = null

    // 塾IDのバリデーションチェック
    errorMessage = this.validAcademyId()
    if (errorMessage) {
      alert(errorMessage)
      this.$loading.complete()
      return
    }

    // 塾情報更新
    await AcademiesApi.updateAcademy(this.academyId, this.modalAcademyData.academyName)

    // 登録APIを追加
    this.$loading.complete()

    // モーダルを閉じる
    this.hide()

    // 塾更新後の処理
    await this.afterUpdateAcademy()
  }

  /**
   * 塾IDのバリデーションチェック
   *
   * @returns 値が無効の場合エラーメッセージを返す
   */
  private validAcademyId(): string | null {
    // IDが初期値0のままの場合
    if (!this.academyId) {
      return '塾IDが無効です'
    }

    return null
  }

  /**
   * モーダルを開く
   *
   * @param academyId 塾ID
   */
  public async show(academyId: number): Promise<void> {
    // 塾ID設定
    this.academyId = academyId

    this.$loading.start()

    // 塾情報取得
    const academy = await AcademiesApi.getAcademy(academyId)

    this.$loading.complete()

    // モーダルを開く
    this.modalAcademyData.show(academy.name)
  }

  /**
   * モーダルを閉じる
   */
  private hide(): void {
    this.modalAcademyData.hide()
  }
}
